"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _CalendarTable = _interopRequireDefault(require("./CalendarTable"));

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {},
  table: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    "& thead": {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start"
    },
    "& tbody": {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start"
    },
    "& tr": {
      display: "flex",
      alignItems: "flex-start",
      width: "100%",
      "& > *": {
        width: theme.spacing(4)
      }
    }
  },
  weekday: {
    display: "flex",
    width: theme.spacing(4),
    height: theme.spacing(4),
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Akkurat, sans-serif",
    fontSize: '12px',
    lineHeight: 1
  },
  date: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    margin: 0,
    fontFamily: "Akkurat, sans-serif",
    fontSize: '12px',
    color: theme.palette.text.disabled,
    lineHeight: 1,
    "&[data-month=true]": {
      color: theme.palette.text.primary
    },
    "&[data-today=true]": {
      border: "1px solid",
      borderColor: theme.palette.primary.main
    },
    "&[data-selected=true]": {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    }
  }
}));

const NavCalendar = ({
  className,
  format = "YYYY-MM-DD",
  today,
  date,
  startDate,
  endDate,
  onSelect
}) => {
  const classes = useStyles();

  const renderWeekday = ({
    dt
  }) => {
    const weekday = (0, _moment.default)(dt).format('dd').substr(0, 1).toUpperCase();
    return _react.default.createElement("div", {
      className: classes.weekday
    }, weekday);
  };

  const renderDate = ({
    dt,
    dtMonth
  }) => {
    const selected = date === dt;
    return _react.default.createElement(_IconButton.default, {
      className: classes.date,
      onClick: e => onSelect && onSelect({
        date: dt
      }, e),
      "data-selected": selected,
      "data-month": dtMonth
    }, (0, _moment.default)(dt).format('D'));
  };

  return _react.default.createElement("nav", {
    className: className || classes.root
  }, _react.default.createElement(_CalendarTable.default, {
    dt: date,
    className: classes.table,
    renderWeekday: renderWeekday,
    renderDate: renderDate
  }));
};

var _default = NavCalendar;
exports.default = _default;
module.exports = exports.default;